import { Priority as PriorityEnum } from '@/projects/models/IProject'

export const priorities = [
  { id: PriorityEnum.High, title: 'High', color: '#ef4444' },
  { id: PriorityEnum.Medium, title: 'Medium', color: '#eab308' },
  { id: PriorityEnum.Low, title: 'Low', color: '#65a30d' },
]
